import { Component, OnInit, ViewChild } from '@angular/core';

import { TreeNode } from 'primeng/api';
import { catchError, map } from 'rxjs/operators';

import { BreadcrumbService } from 'src/app/core/framework/breadcrumb.service';
import { Status } from 'src/app/core/framework/default.model';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { ChaveConfiguracao } from 'src/app/core/multi-tenancy/chave-configuracao.enum';
import { Parametro } from 'src/app/core/multi-tenancy/parametro.model';
import { ParametroService } from 'src/app/seguranca/configuracao/parametro/parametro.service';
import { CfgIntegracaoModulo } from '../../model/cfg-integracao-modulo.model';
import { CfgIntegracaoModuloService } from '../modulo/cfg-integracao-modulo.service';
import { CfgIntegracaoModuloFilter } from '../modulo/model/cfg-integracao-modulo.filter';
import { TipoIntegracao } from '../modulo/model/tipo-integracao.enum';
import { PopoverEditorUrlComponent } from '../popover-editor-url/popover-editor-url.component';


@Component({
  selector: 'app-cfg-integracao-home',
  templateUrl: './cfg-integracao-home.component.html',
  styleUrls: ['./cfg-integracao-home.component.css']
})
export class CfgIntegracaoHomeComponent implements OnInit {

  @ViewChild('popoverEditorUrl') private popoverEditorUrl: PopoverEditorUrlComponent;
  parametroCriptografia: Parametro = null;
  chaveCriptografia = '';
  chaveCriptografiaInputType = "password";

  arvore: TreeNode[] = [];
  modulos: CfgIntegracaoModulo[];

  constructor(
    private cfgIntegracaoModuloService: CfgIntegracaoModuloService
    , private breadcrumbService: BreadcrumbService
    , private toasterService: ToasterService
    , private parametroService: ParametroService
  ) { }

  ngOnInit(): void {
    this.carregarBreadcrumb();
    this.carregarArvore();
    this.carregarChaveDeCriptografia();
  }

  fnExibirChaveCriptografia(): void {
    if ( this.chaveCriptografiaInputType === 'password' ) {
      this.chaveCriptografiaInputType = 'text';
    }
    else {
      this.chaveCriptografiaInputType = 'password';
    }
  }

  // apagarChaveCriptografia(): void {
  //   this.parametroCriptografia.valor = '';

  //   this.parametroService
  //       .atualizar(this.parametroCriptografia.id, this.parametroCriptografia)
  //       .subscribe(result => this.toasterService.success());
  // }  

  // gerarNovaChaveCriptografia(): void {
  //   this.parametroCriptografia.valor = '' + StringUtil.getRandomInt();

  //   this.parametroService
  //       .atualizar(this.parametroCriptografia.id, this.parametroCriptografia)
  //       .subscribe(result => this.toasterService.success());
  // }

  private carregarChaveDeCriptografia(): void {
    this.parametroService
        .buscar(ChaveConfiguracao.CFG_INTEGRACAO, "CHAVE_CRIPTOGRAFIA")
        .subscribe((parametro: Parametro) => {
          this.parametroCriptografia = parametro;
          if ( parametro && parametro.valor ) {
            this.chaveCriptografia = parametro.valor;
          }
        });
  }

  private carregarBreadcrumb(): void {
    this.breadcrumbService.setItems([
      {label: 'Segurança'}, { label: 'Configuração' }, { label: 'Integração de APIs' }
    ]);

    this.breadcrumbService.setMenuConfig(
      this.breadcrumbService.getOrCreateMenuConfig()
          .hideAll()
          .setShowVoltar(true)
          .setExtraButtons([{
            mat_icon: 'subject'
            , id: ''
            , title: 'Editar URLs base em lote...'
            , visible: true
            , args: null
            , command: (e) => this.abrirPopoverDoEditorDeUrlEmLote(e)
          }])
    );
  }

  public atualizarParentEventEmitter(): void {
    this.carregarArvore();
  }

  private abrirPopoverDoEditorDeUrlEmLote(event: any): void {
    this.popoverEditorUrl.show(event);
  }

  private carregarArvore(): void {
    const toasterId = this.toasterService.loading();
    this.limparArvore();
    
    const filter: CfgIntegracaoModuloFilter = {
      status: Status.ATIVO,
      tipoIntegracao: TipoIntegracao.CALLBACK_REQUEST
    };

    this.cfgIntegracaoModuloService
        .listar(filter)
        .pipe(
          map(result => {
            this.modulos = result.content;
            this.popularArvore();
          })
          , catchError(err => {
            this.toasterService.clearWait(toasterId);
            return err;
          })
        )
        .subscribe(() => this.toasterService.clearWait(toasterId));
  }

  private limparArvore(): void {
    this.arvore = [];
  }

  private popularArvore(): void {
    const root: TreeNode = {
      label: 'Integrações',
      children: [],
      expanded: true
    };

    for ( const m of this.modulos ) {
      const noModulo: TreeNode = {
        label: m.nome,
        children: [],
        expanded: true
      };

      for ( const gf of m.cfgIntegracaoGruposFuncao ) {
        const noGrupoFuncoes: TreeNode = {
          label: gf.nome,
          children: [],
          expanded: true
        };
        
        for ( const e of gf.cfgIntegracaoEventos ) {
          const noEvento: TreeNode = {
            label: e.nome,
            leaf: true,
            expanded: true,
            type: 'cfg-integracao-evento',
            data: e,
            selectable: false
          }
          noGrupoFuncoes.children.push(noEvento);
        }

        noModulo.children.push(noGrupoFuncoes);
      }

      root.children.push(noModulo);
    }

    this.arvore = [{
      label: 'Integrações',
      children: root.children
    }];

    this.expandAll();
  }


  private expandAll(){
    this.arvore.forEach( node => {
        this.expandRecursive(node, true);
    } );
  }

  private expandRecursive(node:TreeNode, isExpand:boolean){
    node.expanded = isExpand;
    if(node.children){
        node.children.forEach( childNode => {
            this.expandRecursive(childNode, isExpand);
        } );
    }
  }


}
